/* =========================================================
   Header v2 — Menu burger, recherche prédictive, overlay
   (Aucun cart drawer ici : le lien "Cart" va vers /cart)
   ========================================================= */

(function(){
  /* -------------------------------------------------------
   *  Utils de sélection
   * ----------------------------------------------------- */
  const $  = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => Array.from(r.querySelectorAll(s));

  /* -------------------------------------------------------
   *  Références DOM globales
   * ----------------------------------------------------- */
  const navbar        = $('.custom-header');
  const overlay       = $('#overlay');

  // Menu principal
  const menuBtn       = $('.menu-toggle');
  const navDropdown   = $('#nav-dropdown');   // désormais: .open = visible (slide depuis le haut)

  // Recherche
  const searchBtn      = $('.search-toggle');
  const searchDropdown = $('#search-dropdown'); // reste en logique .hidden
  const searchInput    = $('#search-input');    // input barre desktop
  const searchInputMobile = $('#search-input-mobile'); // NOUVEAU: input mobile dans le panneau
  const resultsRail    = $('.search-products-scroll');

  let abortCtrl = null;

  /* -------------------------------------------------------
   * Helpers d’état overlay / header + logique de scroll
   * ----------------------------------------------------- */

  const isMenuOpen   = () => !!navDropdown && (navDropdown.classList.contains('open') || navDropdown.classList.contains('closing'));
  const isSearchOpen = () => !!searchDropdown && (searchDropdown.classList.contains('open') || searchDropdown.classList.contains('closing'));
  const anyPanelOpen = () => isMenuOpen() || isSearchOpen() || document.getElementById('cart-drawer')?.classList.contains('open');

  // 3 états: SOLID (blanc), TRANSPARENT (fond transparent), GHOST (seul le logo visible)
  function setSolid(){
    navbar?.classList.add('is-solid');
    navbar?.classList.remove('transparent','ghost','fade-out','will-fade');
  }
  function setTransparent(){
    if (!navbar) return;
    navbar.classList.remove('is-solid','ghost','fade-out','will-fade');
    navbar.classList.add('transparent');
  }
  function setGhost(){
    if (!navbar) return;
    navbar.classList.remove('is-solid','transparent','fade-out','will-fade');
    navbar.classList.add('ghost');
  }

  function showOverlay(){ overlay?.classList.add('active'); }
  function hideOverlayIfNone(){ if (!anyPanelOpen()) overlay?.classList.remove('active'); }

  // Blanc 3s, puis transparent si en haut et rien d’ouvert
  setSolid();
  setTimeout(()=>{ if (!anyPanelOpen() && window.scrollY === 0) setTransparent(); }, 3000);

  // Hover header
  navbar?.addEventListener('mouseenter', ()=>{ setSolid(); });
  navbar?.addEventListener('mouseleave', ()=>{
    if (anyPanelOpen()) return;
    if (window.scrollY <= 0) setTransparent(); else setGhost();
  });

  // Scroll: bas -> ghost ; haut -> solid
  let lastY = window.scrollY;
  let ticking = false;
  function onScroll(){
    const y = window.scrollY;
    const goingDown = y > lastY + 2;
    const goingUp   = y < lastY - 2;
    lastY = y;
    if (anyPanelOpen()) return;
    if (goingDown) setGhost();
    else if (goingUp) setSolid();
    else if (y === 0) setTransparent();
    ticking = false;
  }
  window.addEventListener('scroll', ()=>{ if (!ticking){ window.requestAnimationFrame(onScroll); ticking = true; } });

  // Forcer blanc si panneau ouvert
  function forceSolidWhilePanels(){ if (anyPanelOpen()) setSolid(); }
  document.addEventListener('click', forceSolidWhilePanels, true);

  // Header interactif
  function enableHeaderInteractive(){ navbar?.classList.add('interactive'); navbar?.classList.add('is-solid'); }
  function disableHeaderInteractiveIfNone(){
    const cartOpen   = document.getElementById('cart-drawer')?.classList.contains('open');
    if (!isMenuOpen() && !isSearchOpen() && !cartOpen){ navbar?.classList.remove('interactive'); }
  }

  // Hotfix: hover réactive les clics
  navbar?.addEventListener('mouseenter', () => { navbar.classList.add('interactive'); setSolid(); });
  navbar?.addEventListener('mouseleave', () => {
    const cartOpen   = document.getElementById('cart-drawer')?.classList.contains('open');
    const menuOpen   = document.getElementById('nav-dropdown')?.classList.contains('open');
    const searchOpen = document.getElementById('search-dropdown')?.classList.contains('open');
    if (!menuOpen && !searchOpen && !cartOpen){
      navbar.classList.remove('interactive');
      if (window.scrollY > 0) setGhost(); else setTransparent();
    }
  });

  // alias
  const setHeaderSolid = setSolid;

  /* -------------------------------------------------------
   * Menu principal
   * ----------------------------------------------------- */
  function openMenu(){
    closeSearch();
    navDropdown?.classList.remove('hidden');
    navDropdown?.classList.add('open');
    menuBtn?.setAttribute('aria-expanded','true');
    showOverlay();
    setSolid();
    enableHeaderInteractive();
  }

  function closeMenu() {
    if (!navDropdown?.classList.contains('open')) return;
    navDropdown.classList.add('closing');
    const onEnd = (e) => {
      if (e.propertyName !== 'transform') return;
      navDropdown.removeEventListener('transitionend', onEnd);
      navDropdown.classList.remove('closing', 'open');
      hideOverlayIfNone();
      setHeaderSolid(false);
      disableHeaderInteractiveIfNone();
    };
    navDropdown.addEventListener('transitionend', onEnd);
    menuBtn?.setAttribute('aria-expanded', 'false');
  }

  function toggleMenu(){ isMenuOpen() ? closeMenu() : openMenu(); }

  /* -------------------------------------------------------
   * Recherche
   * ----------------------------------------------------- */
  function openSearch() {
    closeMenu();
    searchDropdown?.classList.remove('hidden');
    searchDropdown?.classList.add('open');
    searchBtn?.setAttribute('aria-expanded', 'true');
    searchInput?.setAttribute('aria-expanded', 'true');
    showOverlay();
    setHeaderSolid();
    enableHeaderInteractive();

    const isMobile = window.matchMedia('(max-width: 900px)').matches;

    if (isMobile && searchInputMobile){
      searchInputMobile.placeholder = 'Search...';
      searchInputMobile.classList.add('active');
      searchInputMobile.focus();
      if (resultsRail && (!searchInputMobile.value || !searchInputMobile.value.trim())) { loadDefaultProducts(); }
    } else if (searchInput) {
      searchInput.placeholder = 'Recherchez ici';
      searchInput.classList.add('active');
      searchInput.focus();
      if (resultsRail && (!searchInput.value || !searchInput.value.trim())) { loadDefaultProducts(); }
    }
  }

  function closeSearch() {
    if (!searchDropdown?.classList.contains('open')) return;
    searchDropdown.classList.add('closing');
    const onEnd = (e) => {
      if (e.propertyName !== 'transform') return;
      searchDropdown.removeEventListener('transitionend', onEnd);
      searchDropdown.classList.remove('closing', 'open');
      searchBtn?.setAttribute('aria-expanded', 'false');
      searchInput?.setAttribute('aria-expanded', 'false');
      hideOverlayIfNone();
      setHeaderSolid(false);
      disableHeaderInteractiveIfNone();
    };
    searchDropdown.addEventListener('transitionend', onEnd);
  }

  function toggleSearch() { isSearchOpen() ? closeSearch() : openSearch(); }

  /* -------------------------------------------------------
   *  Overlay + ESC
   * ----------------------------------------------------- */
  overlay?.addEventListener('click', () => { closeMenu(); closeSearch(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape'){ closeMenu(); closeSearch(); } });

  /* -------------------------------------------------------
   *  Bind boutons nav
   * ----------------------------------------------------- */
  menuBtn?.addEventListener('click', (e)=>{ e.preventDefault(); toggleMenu(); });
  searchBtn?.addEventListener('click', (e)=>{ e.preventDefault(); toggleSearch(); });

  /* -------------------------------------------------------
   *  Recherche prédictive Shopify
   * ----------------------------------------------------- */
  function debounce(fn, wait=220){
    let t; return (...args)=>{ clearTimeout(t); t = setTimeout(()=>fn(...args), wait); };
  }

  function getLocaleAndCurrency(){
    const el = searchDropdown;
    const locale   = el?.dataset?.locale || 'fr-FR';
    const currency = el?.dataset?.currency || 'EUR';
    return { locale, currency };
  }
  function toNumber(val){
    if (typeof val === 'number') return val;
    if (typeof val !== 'string') return NaN;
    const num = Number(val.replace(/[^0-9.,-]/g,'').replace(',', '.'));
    return isNaN(num) ? NaN : num;
  }
  function formatMoneyRaw(raw){
    const { locale, currency } = getLocaleAndCurrency();
    const n = toNumber(raw);
    if (!isNaN(n)){
      try{ return new Intl.NumberFormat(locale, { style:'currency', currency }).format(n); }
      catch(e){ return `${n.toFixed(2)} ${currency}`; }
    }
    return String(raw);
  }

  async function fetchSearch(query){
    if (!query || !resultsRail) return;
    abortCtrl?.abort();
    abortCtrl = new AbortController();
    try{
      const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=20&section_id=predictive-search`;
      const res = await fetch(url, { signal: abortCtrl.signal });
      const data = await res.json();
      const results = data?.resources?.results?.products || [];
      if (!results.length){
        resultsRail.innerHTML = `<div class='no-results'>Aucun produit trouvé.</div>`;
        openSearch();
        return;
      }
      resultsRail.innerHTML = results.map(p => `
        <a class="product" href="${p.url}">
          <div class="product-image"><img src="${p.image}" alt="${p.title}"></div>
          <div class="product-info">
            <span class="product-name">${p.title}</span>
            <span class="product-price">${formatMoneyRaw(p.price)}</span>
          </div>
        </a>
      `).join('');
      openSearch();
    } catch(e){
      if (e.name === 'AbortError') return;
      resultsRail.innerHTML = `<div class='no-results'>Erreur de recherche.</div>`;
      openSearch();
    }
  }
  const debouncedFetch = debounce(fetchSearch, 220);

  async function loadDefaultProducts(){
    if (!resultsRail) return;
    try{
      const res = await fetch(`/products.json?limit=12`);
      const data = await res.json();
      const products = data?.products || [];
      if (!products.length){
        resultsRail.innerHTML = `<div class='no-results'>Aucun produit disponible pour le moment.</div>`;
        return;
      }
      resultsRail.innerHTML = products.map(p=>{
        const img = (p.images && p.images[0] && (p.images[0].src || p.images[0].url)) || 'https://via.placeholder.com/295x365';
        const price = (p.variants && p.variants[0] && p.variants[0].price) ? p.variants[0].price : '';
        return `
          <a class="product" href="/products/${p.handle}">
            <div class="product-image"><img src="${img}" alt="${p.title}"></div>
            <div class="product-info">
              <span class="product-name">${p.title}</span>
              <span class="product-price">${formatMoneyRaw(price)}</span>
            </div>
          </a>
        `;
      }).join('');
    }catch(e){
      resultsRail.innerHTML = `<div class='no-results'>Impossible de charger les produits.</div>`;
    }
  }

  // Inputs recherche (desktop + mobile)
  if (searchInput){
    searchInput.addEventListener('input', (e)=>{
      const q = e.target.value.trim();
      if (!q) return;
      debouncedFetch(q);
    });
  }
  if (searchInputMobile){
    searchInputMobile.addEventListener('input', (e)=>{
      const q = e.target.value.trim();
      if (!q) return;
      debouncedFetch(q);
    });
  }

  /* -------------------------------------------------------
   *  Hover preview images dans le mega menu
   * ----------------------------------------------------- */
  (function bindHoverPreview(){
    const preview = document.getElementById('hover-image');
    const nav = document.getElementById('nav-dropdown');
    if (!preview || !nav) return;

    function swapPreview(primary, secondary, fallback){
      const candidates = [primary, secondary, fallback].filter(Boolean);
      let i = 0;
      function tryNext(){
        if (i >= candidates.length) return;
        const src = candidates[i++];
        const test = new Image();
        test.onload = () => { preview.src = src; };
        test.onerror = tryNext;
        test.src = src;
      }
      tryNext();
    }

    nav.querySelectorAll('a[data-image]').forEach(link => {
      link.addEventListener('mouseenter', () => {
        const primary   = (link.getAttribute('data-image') || '').trim() || null;
        const column    = link.closest('.content-column');
        const secondary = column?.getAttribute('data-fallback') || null;
        const fallback  = preview.dataset.default || preview.getAttribute('src') || null;
        swapPreview(primary, secondary, fallback);
      });
    });

    nav.addEventListener('mouseleave', () => {
      const def = preview.dataset.default || null;
      if (def) preview.src = def;
    });
  })();

  /* -------------------------------------------------------
   *  Drag-to-scroll (rail desktop, non bloquant pour mobile)
   * ----------------------------------------------------- */
  (function bindDragScroll(){
    const sc = document.querySelector('.search-products-scroll');
    if (!sc) return;
    let isDown=false, startX=0, scrollLeft=0;
    sc.addEventListener('mousedown',(e)=>{
      isDown = true; sc.classList.add('active');
      startX = e.pageX - sc.offsetLeft; scrollLeft = sc.scrollLeft;
    });
    ['mouseleave','mouseup'].forEach(ev=> sc.addEventListener(ev,()=>{ isDown = false; sc.classList.remove('active'); }));
    sc.addEventListener('mousemove',(e)=>{
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - sc.offsetLeft;
      const walk = (x - startX) * 1.5;
      sc.scrollLeft = scrollLeft - walk;
    });
  })();

  /* -------------------------------------------------------
   *  Init état header
   * ----------------------------------------------------- */
  setHeaderSolid();
})();

/* ==========================
   CART DRAWER (Shopify AJAX)
   ========================== */
(function(){
  function initCartDrawer(){
    const cartDrawer   = document.getElementById('cart-drawer');
    const overlay      = document.getElementById('overlay');
    const header       = document.querySelector('.custom-header');

    if (!cartDrawer) return;

    // Buttons / areas
    const openCartLinks = Array.from(document.querySelectorAll('.nav-link-cart, .open-cart'));
    const closeBtn      = cartDrawer.querySelector('.cart-close');
    const cartBody      = cartDrawer.querySelector('.cart-body');
    const cartTitle     = cartDrawer.querySelector('.cart-title');
    const cartTotalEl   = cartDrawer.querySelector('.total-right');
    const fsFill        = cartDrawer.querySelector('.fs-fill');
    const fsText        = cartDrawer.querySelector('.fs-text');

    // Context
    const locale   = cartDrawer.dataset.locale   || 'en-GB';
    const currency = cartDrawer.dataset.currency || 'EUR';
    const FREE_SHIPPING_LIMIT = 250; // €

    // Utils
    function formatMoney(cents){
      const n = (cents || 0) / 100;
      try{ return new Intl.NumberFormat(locale, { style:'currency', currency }).format(n); }
      catch(_){ return n.toFixed(2).replace('.', ',') + ' €'; }
    }
    function escapeHtml(s){
      return String(s || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
    }
    function isPanelOpen(el){
      return !!el && (el.classList.contains('open') || el.classList.contains('closing'));
    }
    function anyMenuOrSearchOpen(){
      const menuEl   = document.getElementById('nav-dropdown');
      const searchEl = document.getElementById('search-dropdown');
      return isPanelOpen(menuEl) || isPanelOpen(searchEl);
    }
    function keepHeaderSolid(){ header?.classList.add('is-solid'); }
    function fadeHeaderTransparentAfter(ms){
      if (anyMenuOrSearchOpen()) return;
      setTimeout(()=>{
        if (anyMenuOrSearchOpen()) return;
        if (!header) return;
        header.classList.add('will-fade');
        header.classList.remove('is-solid');
        const onEnd = () => { header.classList.remove('will-fade'); header.removeEventListener('transitionend', onEnd); };
        header.addEventListener('transitionend', onEnd);
      }, ms);
    }

    // Open / Close / Toggle
    async function openCart(e){
      if (e) e.preventDefault();
      const menuToggle   = document.querySelector('.menu-toggle');
      const searchToggle = document.querySelector('.search-toggle');
      const menuIsOpen   = document.getElementById('nav-dropdown')?.classList.contains('open');
      const searchIsOpen = document.getElementById('search-dropdown')?.classList.contains('open');
      if (menuIsOpen)   menuToggle?.click();
      if (searchIsOpen) searchToggle?.click();

      await loadCart();

      cartDrawer.classList.add('open');
      cartDrawer.setAttribute('aria-hidden','false');
      overlay?.classList.add('active');

      keepHeaderSolid();
      document.querySelector('.custom-header')?.classList.add('interactive');
    }

    function closeCart(){
      cartDrawer.classList.remove('open');
      cartDrawer.setAttribute('aria-hidden','true');
      overlay?.classList.remove('active');

      const menuOpen   = document.getElementById('nav-dropdown')?.classList.contains('open');
      const searchOpen = document.getElementById('search-dropdown')?.classList.contains('open');

      if (!menuOpen && !searchOpen){
        document.querySelector('.custom-header')?.classList.remove('interactive');
        fadeHeaderTransparentAfter(2000);
      }
    }

    function toggleCart(e){
      if (e) e.preventDefault();
      cartDrawer.classList.contains('open') ? closeCart() : openCart();
    }

    // Listeners
    openCartLinks.forEach(a => a.addEventListener('click', toggleCart));
    closeBtn?.addEventListener('click', (e)=>{ e.preventDefault(); closeCart(); });
    overlay?.addEventListener('click', () => { if (cartDrawer.classList.contains('open')) closeCart(); });
    document.addEventListener('keydown', (e)=>{ if (e.key === 'Escape' && cartDrawer.classList.contains('open')) closeCart(); });
    document.querySelector('.menu-toggle')  ?.addEventListener('click', () => { if (cartDrawer.classList.contains('open')) closeCart(); });
    document.querySelector('.search-toggle')?.addEventListener('click', () => { if (cartDrawer.classList.contains('open')) closeCart(); });

    // Load & render
    async function loadCart(){
      const res  = await fetch('/cart.js', { credentials:'same-origin' });
      const cart = await res.json();
      renderCart(cart);
      return cart;
    }

    function renderCart(cart){
      if (cartTitle) cartTitle.textContent = `Items in your cart: ${cart.item_count}`;

      if (!cart.items || !cart.items.length){
        cartBody.innerHTML = `<div class="cart-empty">Your cart is empty.</div>`;
      } else {
        cartBody.innerHTML = cart.items.map(item => {
          const hasCompareAt = (item.compare_at_price && item.compare_at_price > item.price);
          const hasDiscountAlloc = (item.original_price > item.final_price) || (item.original_line_price > item.final_line_price);

          let oldPriceHtml = '';
          let newPriceHtml = '';

          if (hasCompareAt){
            oldPriceHtml = `<div class="line-price-old">${formatMoney(item.compare_at_price)}</div>`;
            newPriceHtml = `<div class="line-price">${formatMoney(item.price)}</div>`;
          } else if (hasDiscountAlloc){
            oldPriceHtml = `<div class="line-price-old">${formatMoney(item.original_price)}</div>`;
            newPriceHtml = `<div class="line-price">${formatMoney(item.final_price)}</div>`;
          } else {
            newPriceHtml = `<div class="line-price">${formatMoney(item.price)}</div>`;
          }

          const vTitle = (item.variant_title || '').trim();
          const parts  = vTitle ? vTitle.split('/').map(s=>s.trim()) : [];
          const size   = parts[0] ? parts[0] : '';
          const color  = parts[1] ? parts[1] : '';

          return `
            <div class="cart-line" role="listitem" data-key="${item.key}">
              <a class="line-media" href="${item.url}">
                <img src="${item.image}" alt="${escapeHtml(item.product_title)}">
              </a>

              <div class="line-info">
                <div class="line-top">
                  <a class="line-title" href="${item.url}">${escapeHtml(item.product_title)}</a>
                  <div class="line-prices">
                    ${oldPriceHtml}
                    ${newPriceHtml}
                  </div>
                </div>

                <div class="line-middle">
                  ${size  ? `<div class="line-attr">Size: ${escapeHtml(size)}</div>`   : ''}
                  ${color ? `<div class="line-attr">Color: ${escapeHtml(color)}</div>` : ''}
                  <div>
                    <div class="line-qtyrow">
                      <span class="qty-label">Qty</span>
                      <button class="qty-btn" data-action="change" data-key="${item.key}" data-delta="-1" aria-label="Decrease">−</button>
                      <span class="qty-value">${item.quantity}</span>
                      <button class="qty-btn" data-action="change" data-key="${item.key}" data-delta="1" aria-label="Increase">+</button>
                    </div>
                    <div class="qty-error" aria-live="polite"></div>
                  </div>
                </div>

                <button class="line-remove" data-action="remove" data-key="${item.key}">Remove</button>
              </div>
            </div>`;
        }).join('');
      }

      if (cartTotalEl) cartTotalEl.textContent = formatMoney(cart.total_price);
      updateFreeShipping(cart);
      updateNavCount(cart);
    }

    cartBody.addEventListener('click', async (e)=>{
      const btn = e.target.closest('[data-action]');
      if (!btn) return;

      const key    = btn.getAttribute('data-key');
      const action = btn.getAttribute('data-action');
      const line   = btn.closest('.cart-line');

      if (action === 'remove'){
        await changeLine(key, 0);
        await loadCart();
        return;
      }

      if (action === 'change'){
        const delta      = parseInt(btn.getAttribute('data-delta'), 10) || 0;
        const currentQty = parseInt(line.querySelector('.qty-value').textContent.trim(), 10) || 1;

        if (delta < 0 && currentQty === 1){
          await changeLine(key, 0);
          await loadCart();
          return;
        }

        const nextQty = Math.max(1, currentQty + delta);
        const changed = await changeLine(key, nextQty);

        const afterItem = changed.items.find(i=>i.key === key);
        const errEl = line.querySelector('.qty-error');

        if (afterItem && afterItem.quantity !== nextQty){
          if (delta > 0 && currentQty === 1 && afterItem.quantity === 1){
            errEl.textContent = "Last item in stock.";
          } else if (delta > 0 && afterItem.quantity < nextQty) {
            errEl.textContent = "Not enough stock available.";
          } else {
            errEl.textContent = "Quantity update not possible.";
          }
        } else {
          errEl.textContent = "";
        }
        renderCart(changed);
      }
    });

    async function changeLine(key, quantity){
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers:{ 'Content-Type':'application/json' },
        body: JSON.stringify({ id:key, quantity })
      });
      if (!res.ok){
        return await fetch('/cart.js').then(r=>r.json());
      }
      return await res.json();
    }

   function updateFreeShipping(cart){
  // Cherche d'abord la version "nouvelle" (.fs-left.fs-text), sinon retombe sur l'ancienne (.fs-text)
  const fsFill   = cartDrawer.querySelector('.fs-fill');
  const fsTextEl = cartDrawer.querySelector('.fs-left.fs-text') || cartDrawer.querySelector('.fs-text');
  if (!fsFill || !fsTextEl) return;

  // On calcule sur le sous-total si dispo (sinon total), en € :
  const subtotalEur = ((typeof cart.items_subtotal_price === 'number' ? cart.items_subtotal_price : cart.total_price) || 0) / 100;

  // % de progression (capé 0–100)
  const progress = Math.min(100, Math.max(0, Math.round((subtotalEur / FREE_SHIPPING_LIMIT) * 100)));
  fsFill.style.setProperty('--fs', progress + '%');

  // Montant restant
  const left = Math.max(0, FREE_SHIPPING_LIMIT - subtotalEur);
  fsTextEl.textContent = left <= 0
    ? 'Free shipping reached 🎉'
    : `You're ${left.toLocaleString(locale, { maximumFractionDigits: 2 })} € away from free shipping`;
}



    function updateNavCount(cart){
      const link = document.querySelector('.nav-link-cart');
      if (!link) return;
      link.textContent = `Cart ${cart.item_count}`;
    }
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initCartDrawer);
  } else {
    initCartDrawer();
  }

  
})();
